import {
  DisclaimerApi,
  DisclaimerGetAllRequest,
  DisclaimerGetRequest,
  DisclaimerItemDto,
  DisclaimerPutBulkRequest,
  DisclaimerPutRequest,
  InitOverrideFunction,
} from "../../../@api";

export class DisclaimerApiService
  implements Omit<DisclaimerApi, `${string}Raw` | "withMiddleware" | "withPreMiddleware" | "withPostMiddleware">
{
  constructor(private readonly api: DisclaimerApi) {}

  disclaimerGet(
    requestParameters: DisclaimerGetRequest,
    initOverrides?: RequestInit | InitOverrideFunction,
  ): Promise<DisclaimerItemDto> {
    return this.api.disclaimerGet(requestParameters, initOverrides);
  }
  disclaimerGetAll(
    requestParameters?: DisclaimerGetAllRequest,
    initOverrides?: RequestInit | InitOverrideFunction,
  ): Promise<Array<DisclaimerItemDto>> {
    return this.api.disclaimerGetAll(requestParameters, initOverrides);
  }
  disclaimerPut(
    requestParameters?: DisclaimerPutRequest,
    initOverrides?: RequestInit | InitOverrideFunction,
  ): Promise<DisclaimerItemDto> {
    return this.api.disclaimerPut(requestParameters, initOverrides);
  }

  disclaimerPutBulk(
    requestParameters?: DisclaimerPutBulkRequest,
    initOverrides?: RequestInit | InitOverrideFunction,
  ): Promise<Array<DisclaimerItemDto>> {
    return this.api.disclaimerPutBulk(requestParameters, initOverrides);
  }
}
